module.exports = "./img/84be7988a3d1e06de9226756095b5b7c.jpg";